<template>
  <div
    class="content background-home"
    :style="sidebarStyle"
    :data-image="backgroundImage"
  >
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12 text-align-webkit-center">
          <div class="col-md-6 col-lg-6 col-sm-6 mt-6">
            <card class="card-user mt-2 background-card align-center">
              <div class="row">
                <div
                  class="col-md-12"
                  style="text-align: center"
                  v-if="!isForgPsw"
                >
                  <h3 class="card-title">Login</h3>
                  <form class="form-style" action="submit">
                    <base-input
                      type="text"
                      id="email"
                      placeholder="Email"
                      v-model="email"
                    ></base-input>
                    <base-input
                      type="password"
                      id="password"
                      placeholder="Senha"
                      v-model="password"
                    ></base-input>
                    <button
                      type="submit"
                      class="btn btn-success btn-fill float-left"
                      style="margin-top: 20px"
                      @click.prevent
                      @click="submit"
                    >
                      Entrar
                    </button>
                    <button
                      class="btn btn-danger btn-fill float-right"
                      style="margin-top: 20px"
                      @click.prevent
                      @click="forgPsw"
                    >
                      Esqueci Minha Senha
                    </button>
                  </form>
                </div>

                <div
                  class="col-md-12"
                  style="text-align: center"
                  v-if="isForgPsw"
                >
                  <h3 class="card-title">Recupere sua Senha</h3>
                  <form class="form-style" action="submit">
                    <base-input
                      type="text"
                      id="emailResetPsw"
                      placeholder="Digite seu Email"
                      v-model="emailResetPsw"
                    ></base-input>
                    <button
                      type="submit"
                      class="btn btn-success btn-fill float-left"
                      style="margin-top: 20px"
                      @click.prevent
                      @click="resetPsw"
                    >
                      Enviar
                    </button>
                    <button
                      class="btn btn-danger btn-fill float-right"
                      style="margin-top: 20px"
                      @click.prevent
                      @click="forgPsw"
                    >
                      Voltar
                    </button>
                  </form>
                </div>
              </div>
            </card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'lodash';
import UserServices from 'src/services/usuarios';
import Card from 'src/components/Cards/Card.vue';
import { validateEmail } from '../utils';

const VUE_APP_SPINNER_COLOR = process.env.VUE_APP_SPINNER_COLOR;

export default {
  components: {
    Card
  },
  data() {
    return {
      email: '',
      password: '',
      backgroundImage: '/img/home.jpg',
      isForgPsw: false,
      emailResetPsw: '',
      hover: false
    };
  },
  methods: {
    forgPsw() {
      if (this.isForgPsw) {
        this.isForgPsw = false;
      } else {
        this.isForgPsw = true;
      }
    },
    resetPsw() {
      if (!validateEmail(this.emailResetPsw)) {
        this.notifyVue(
          'top',
          'center',
          'danger',
          'Digite um e-mail válido',
          'fa fa-exclamation-triangle'
        );
        return;
      }

      const loader = this.$loading.show({
        color: VUE_APP_SPINNER_COLOR
      });

      const sucessCallback = () => {
        this.notifyVue(
          'top',
          'center',
          'success',
          'Senha resetada. Verifique seu email',
          'fa fa-check'
        );
        loader.hide();
      };

      const errorCallback = err => {
        const message =
          _.get(err, 'response.status') === 400 &&
          _.has(err, 'response.data.message')
            ? _.get(err, 'response.data.message')
            : 'Ocorreu algum erro interno. Tente novamente mais tarde.';

        this.notifyVue(
          'top',
          'center',
          'danger',
          message,
          'fa fa-exclamation-triangle'
        );
        loader.hide();
      };

      UserServices.resetarSenha(this.emailResetPsw)
        .then(sucessCallback)
        .catch(errorCallback);
    },
    notifyVue(verticalAlign, horizontalAlign, type, message, icon) {
      this.$notifications.notify({
        message: `<span>${message}.</span>`,
        icon: icon,
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: type
      });
    },
    submit() {
      if (!validateEmail(this.email)) {
        this.notifyVue(
          'top',
          'center',
          'danger',
          'Digite um e-mail válido',
          'fa fa-exclamation-triangle'
        );
        return;
      }

      const loader = this.$loading.show({
        color: VUE_APP_SPINNER_COLOR
      });

      UserServices.login(this.email, this.password)
        .then(response => {
          loader.hide();
          this.$store.commit('SAVE_USUARIO', _.get(response, 'data'));
          localStorage.setItem(
            'userData',
            JSON.stringify(_.get(response, 'data'))
          );
          if (
            _.get(response, 'data.tipoUsuario') === 'colaborador' ||
            _.get(response, 'data.tipoUsuario') === 'administrador'
          ) {
            this.$router.replace('controle-usuarios');
          } else if (_.get(response, 'data.tipoUsuario') === 'parceiro') {
            this.$router.replace('produtos');
          } else if (_.get(response, 'data.tipoUsuario') === 'vendedor') {
            this.$router.replace('perfil'); // MUDAR
          }
        })
        .catch(err => {
          const message =
            _.get(err, 'response.status') === 400 &&
            _.has(err, 'response.data.message')
              ? _.get(err, 'response.data.message')
              : 'Ocorreu algum erro interno. Tente novamente mais tarde.';

          this.notifyVue(
            'top',
            'center',
            'danger',
            message,
            'fa fa-exclamation-triangle'
          );
          loader.hide();
        });
    }
  },
  computed: {
    sidebarStyle() {
      return {
        backgroundImage: `url(${this.backgroundImage})`,
        backgroundSize:
          'cover' /* Resize the background image to cover the entire container */
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.logo {
  max-width: 120%;
}
.align-center {
  align-self: center;
}
.container {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center 10;
}
.image-align {
  padding-right: 8%;
  padding-left: 0%;
  margin-left: -7%;
  margin-right: 0%;
  margin-top: 0%;
  margin-bottom: 0%;
  transition: all 1s;
  z-index: 999;
  position: absolute;
}

@media (max-width: 767px) {
  .image-align {
    position: relative;
  }
}

@media (max-height: 600px) {
  .image-align {
    margin-top: -33% !important;
    transform: scale(0.8);
  }
}

@media (min-width: 400px) {
  .image-align {
    transform: scale(0.8) !important;
  }
}

.height-home {
  height: 100%;
}
img.logo.image-align:hover {
  transform: scale(1.2);
}

.form-style {
  margin-top: 20px;
}

.background-card {
  background-color: rgba(41, 137, 41, 0.2);
}

.background-home {
  height: -webkit-fill-available;
}

.join-logo {
  align-self: center;
}

.height-join {
  height: 70%;
}

.whatsapp-button {
  position: fixed;
  bottom: 16px;
  right: 16px;
  box-sizing: border-box;
  height: 60px;
  width: 60px;
  cursor: pointer;
  box-shadow: 0 0 5px #444;
  transition-duration: 0.1s;
}

.whatsapp-button:hover {
  box-shadow: 0 0 10px #444;
}

.whatsapp-logo {
  position: absolute;
  width: 60px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.text-align-webkit-center {
  text-align: -webkit-center;
}
</style>
